export default class FtUmkmPermit {
  constructor(
    id,
    kode1,
    fumkmBean,
    fpermitBean,
    fdivisionBean,

    created,
    modified,
    modifiedBy
  ) {
    this.id = id;
    this.kode1 = kode1;
    this.fumkmBean = fumkmBean;
    this.fpermitBean = fpermitBean;
    this.fdivisionBean = fdivisionBean;

    this.created = created;
    this.modified = modified;
    this.modifiedBy = modifiedBy;
  }
}
